export enum UploadingToolFileTypesEnum {
  Tpa = 1,
  NetworkProviders,
  Labs = 3,
  Radiology = 4,
  FDO = 5
}